import { atom } from "jotai";
import { ResponseGetMerchflows_merchflowId_StoresAll } from "@CommonApi/merchflows/_merchflowId_/stores/all";

export interface UpdateStoreProductsModalData {
  data: ResponseGetMerchflows_merchflowId_StoresAll;
  merchflowId: number;
}

export const updateStoreProductsModalDataAtom = atom<UpdateStoreProductsModalData | null>(null);
